import script from "./AdminCompBasicEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminCompBasicEdit.vue?vue&type=script&setup=true&lang=ts"

import "./AdminCompBasicEdit.vue?vue&type=style&index=0&id=0e9650b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e9650b6"]])

export default __exports__